exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._7LRAQO32gMqkWKCxjh6Z0{height:300px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background-color:#263238}._3Cm3o6TGLUC2bgnaOTaG0J{display:block}._3v1vj-26flL2JqdsRr5Zvj{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._3v1vj-26flL2JqdsRr5Zvj,.P85uSql616pFjn4_bLL2D{display:-webkit-box;display:-ms-flexbox;display:flex}.P85uSql616pFjn4_bLL2D{max-width:600px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:15px 20px 20px;background-color:#eceff1;box-shadow:1px 1px 1px 1px rgba(0,0,0,.05);border-radius:.5em;margin:1pc;margin:1rem}._1byQZYLRuCnRfdT-9vdgC_{text-align:center;color:#37474f;font-size:.8em}", ""]);

// exports
exports.locals = {
	"headerRow": "_7LRAQO32gMqkWKCxjh6Z0",
	"logo": "_3Cm3o6TGLUC2bgnaOTaG0J",
	"body": "_3v1vj-26flL2JqdsRr5Zvj",
	"card": "P85uSql616pFjn4_bLL2D",
	"footer": "_1byQZYLRuCnRfdT-9vdgC_"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/cssnext-loader!./website/Application.css
// module id = 277
// module chunks = 0